import { io } from 'socket.io-client';

let socket = null;

export function connectChat(token, apiUrl) {
  // Socket już istnieje — NIE twórz drugiego (to plodziło martwe duplikaty przy
  // wyścigu initGlobalChat vs ChatPage). Jeśli spadł (np. restart backendu przy
  // deployu), reanimuj tę samą instancję zamiast go porzucać.
  if (socket) {
    if (!socket.connected) socket.connect();
    return socket;
  }

  // Remove trailing slash and any path from API URL to get base server URL
  const baseUrl = apiUrl.replace(/\/+$/, '');

  socket = io(baseUrl + '/chat', {
    auth: { token },
    reconnection: true,
    // Nigdy się nie poddawaj — backend bywa offline dłużej (bramka Approve na
    // Railway). Przy 10 próbach socket umierał na stałe i czat „nie odświeżał
    // się" aż do przeładowania strony. Infinity => wraca sam, gdy backend wróci.
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
    transports: ['websocket', 'polling'],
  });

  return socket;
}

export function getSocket() {
  return socket;
}

export function disconnectChat() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
